
<template>
    <div class="intro-page">
        <div class="page-header">中医传承工作站介绍</div>
        <p class="page-text">中医传承工作站由中国中医科学院中医药信息研究所与上海道生医疗科技有限公司、北京云知声信息技术有限公司联合研制开发的软硬件集成平台，面向医院、科研院所、高校、及各名医传承工作室/站，实现诊疗信息采集、储存、分析一站完成。</p>
            
        <div class="page-info">
            <ul class="flex-info">
                <li class="info-list"> 
                    <span class="icon1"></span>
                   诊疗信息客观化采集、储存、分析一站完成 </li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                   中医药专业语音识别，支持语音录入医案 </li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                   古今30万权威医案资源在线检索</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                   5万专业术语支撑，智能规范化处理</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                   共建共享积分服务，支持个人病案与文献医案交互分析</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                   专业团队维护，系统自动升级</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                    病案自由录入与结构化采集相结合，满足多种采集需求</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                    多种格式医案数据导入导出，便捷对接其他平台</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                    真实场景下医案采集模式，实时处方打印功能</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                    支持移动端及PC端医案录入</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                    工作组医案共建共享，保障内部数据安全</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                    提供信息、四诊、病症、治法、处方、用药、选穴、疗效、多维九个分析模块</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                    集成频次统计、关联分析、卡方检验、社团分析、互信息、复杂网络等算法</li>
                <li class="info-list"> 
                    <span class="icon1"></span>
                    模块化数据挖掘，一键生成医案集</li>
            </ul>
            <el-carousel class="customize-list" indicator-position="outside" :interval="5000" type="card" height="320px">
                <el-carousel-item  class="list" v-for="(item,index) in customizeList" :key="index">
                    <div class="list-pic">
                        <img :class="item.type=='height'?'img-height':'img-width'" :src="item.pic" alt="">
                    </div>
                </el-carousel-item>
            </el-carousel> 
            <ul class="info-border">
                <li class="info-list">
                    <el-row >
                        <el-col :span='3' class="list-tit"><span class="icon"></span>舌诊 </el-col>
                        <div class="list-img">
                            <el-col :span='5' class="img">
                                <img src="../../assets/images/diagnose1.jpg" alt="">
                            </el-col>
                            <el-col :span='5' class="img">
                                <img src="../../assets/images/diagnose2.jpg" alt="">
                            </el-col>
                            <el-col :span='13' class="img">
                                <img src="../../assets/images/diagnose3.jpg" alt="">
                            </el-col>
                        </div>
                    </el-row>
                </li>
                <li class="info-list">
                    <el-row >
                        <el-col :span='3' class="list-tit"><span class="icon"></span>脉诊 </el-col> 
                        <div class="list-img">
                            <el-col :span='5' class="img">
                                <img src="../../assets/images/pulse1.jpg" alt="">
                            </el-col>
                            <el-col :span='5' class="img">
                                <img src="../../assets/images/pulse2.jpg" alt="">
                            </el-col>
                            <el-col :span='13' class="img">
                                <img src="../../assets/images/pulse3.jpg" alt="">
                            </el-col>
                        </div>
                    </el-row>
                </li>
                <li class="info-list">
                    <el-row > 
                        <el-col :span='3' class="list-tit"><span class="icon"></span>语音识别 </el-col> 
                        <el-col :span='10' class="mar-top20">
                            <p class="txt">通过麦克风口述患者病情，完成门诊/住院病历电子化书写</p>
                            <div class="img">
                                <img src="../../assets/images/voice1.jpg" alt="">
                            </div>
                        </el-col> 
                        <!-- <div class="list-img">
                            <el-col :span='12' class="img">通过麦克风口述患者病情，完成门诊/住院病历电子化书写</el-col>
                            <el-col :span='8' class="img">
                                <img src="../../assets/images/voice1.jpg" alt="">
                            </el-col> 
                        </div> -->
                    </el-row>
                </li>
                <li class="info-list">
                    <el-row> 
                         <el-col :span='3' class="list-tit"><span class="icon"></span>OCR </el-col> 
                         <el-col :span='8'  >
                            <p class="txt">通过OCR识别，完成纸质病历电子化录入</p>
                             <div class="img">
                                <img src="../../assets/images/ocr.jpg" alt="">
                            </div>
                        </el-col>  
                        
                    </el-row>
                </li>
            </ul>
        </div> 
        <introFooter></introFooter>
    </div>
</template>

<script>
import introFooter from './intro_footer.vue'
export default {
    components: {
        introFooter,
    },
    data () {
        return {
            customizeList:[
                {
                    pic:require('../../assets/images/apparatus1.jpg'), 
                    type:'height',
                },
                {
                    pic:require('../../assets/images/apparatus2.jpg'), 
                    type:'height',
                },
                {
                    pic:require('../../assets/images/apparatus3.jpg'), 
                    type:'width',
                },
                {
                    pic:require('../../assets/images/apparatus4.jpg'), 
                    type:'width',
                },
            ]
        }
    }
}
</script>


<style lang="less"> 
    @import url('../../css/intro_page.less');  
    
</style>